angular.module('dnecom')
    .controller('FulfillmentDetailsConfirmController', ["$scope", "$uibModalInstance", "details", function FulfillmentDetailsReviewController($scope, $uibModalInstance, details) {
        $scope.confirm = function(mode) {
            $uibModalInstance.close(mode);
        };

        $scope.closeModal = function () {
            $uibModalInstance.dismiss();
        };
    }]);
